
import styles from "./TestPage.module.scss";
import { Button, Layout } from "components";
import { useEffect, useState } from "react";
import Notification from "utils/Notifications";
import { PostTest } from "service/TestService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import TestBody from "./components/TestBody";
import { getTestData, getTestUserData, getTestUserAll } from "service/TestService";
import rewIcon from "assets/icons/pdf.png";
import filerew from 'assets/files/📝_Руководство_пользователя_по_системе_тестирования.pdf'

const TestPage = () => {
  const [activeTab, setActiveTab] = useState('available');
  const [openModal, setOpenModal] = useState(false);
  const [body, setBody] = useState("");
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [data, setData] = useState([]);
  const [userdata, setDataForUser] = useState([]);
  const [usedata, setData2] = useState([]);

  const getData = async () => {
    try {
      let response = await getTestData(data);
      setData(response.data);

    } catch (error) {
      console.log("CHU") 
    }
  };

  const getDataForUser = async () => {
    try {
      let response = await getTestUserData(data);
      setDataForUser(response.data);
    } catch (error) {
      console.log("CHU")
    }
  };
  const getDataForUserAll = async () => {
    try {
      let response_user_data = await getTestUserAll(data);
      setData2(response_user_data.data)
    } catch (error) {
      console.log("CHU")
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!body) {
      setNotify({
        isOpen: true,
        message: "Введите наименование теста!",
        type: "error",
      });

    }
    else {
      const formData = new FormData();
      // formData.append('title',title);
      formData.append('title', body);


      let testsinfo = await PostTest(formData);

      getData();

      setBody("");
      setOpenModal(false)
      setNotify({
        isOpen: true,
        message: "Тест успешно создан!",
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };

  useEffect(() => {
    getData();
    getDataForUser();
    getDataForUserAll();
    setRender(false)

  }, [render]);
  return (
    <Layout>
      <div className={styles["test-block"]}>
        <div className={styles["tabs"]}>
          <button
            className={`${styles.tab_btn} ${activeTab === 'available' ? styles.active : ''}`}
            onClick={() => setActiveTab('available')}
          >
            📚 Доступные тесты 
            <span className={styles.h3_3h}>{userdata?.length || 0}</span>
          </button>
          <button
            className={`${styles.tab_btn} ${activeTab === 'completed' ? styles.active : ''}`}
            onClick={() => setActiveTab('completed')}
          >
            ✅ Пройденные 
            <span className={styles.h3_3h}>{usedata?.length || 0}</span>
          </button>
          <button
            className={`${styles.tab_btn} ${activeTab === 'create' ? styles.active : ''}`}
            onClick={() => setActiveTab('create')}
          >
            🛠️ Конструктор 
            <span className={styles.h3_3h}>{data?.length || 0}</span>
          </button>
          <a href={filerew} download className={styles.sign__rew__btn}>
            <span>📝 Руководство</span>
            <img src={rewIcon} alt="Скачать PDF" />
          </a>
        </div>
      
       
        {activeTab === 'create' && (
          <>
          <div className={styles["test-app"]}>
            <h2>🛠️ Конструктор тестов</h2>
            <Button
              className="create__statement__btn"
              onClick={() => setOpenModal(true)}
            >
              + Создать тест
            </Button>
          </div>
          <TestBody data={data} isadmin={true} />
          </>
        )}

        {activeTab === 'available' && (
          <>
            <div className={styles["test-app"]}>
              <h2>📚 Доступные тесты</h2>
            </div>
            <TestBody data={userdata} isadmin={false} />
          </>
        )}

        {activeTab === 'completed' && (
          <>
            <div className={styles["test-app"]}>
              <h2>✅ Пройденные тесты</h2>
            </div>
            <TestBody data={usedata} isadmin={false} log={0} />
          </>
        )}

        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalText='🎓 Создание нового теста'
        >
          <div className={styles["note-input"]}>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Введите название теста"
                className={styles.type_input}
                value={body}
                name="body"
                onChange={(e) => setBody(e.target.value)}
                autoFocus
              />
              <div className={styles.create_footer}>
                <button type="submit" className={styles.open_btn_sub}>
                  Создать
                </button>
                <Button
                  onClick={() => setOpenModal(false)}
                  className={styles.close_btn_sub}
                >
                  Отмена
                </Button>
              </div>
            </form>
          </div>
        </ModalWindow>
        <Notification notify={notify} setNotify={setNotify} />
      </div>
    </Layout>
  );
};

export default TestPage;
